import { render } from "./NewRegistor.vue?vue&type=template&id=36e2baba&scoped=true"
import script from "./NewRegistor.vue?vue&type=script&lang=js"
export * from "./NewRegistor.vue?vue&type=script&lang=js"

import "./NewRegistor.vue?vue&type=style&index=0&id=36e2baba&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-36e2baba"

export default script